import axios from "axios";

const getAllCompanies = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/Companies`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getCompanies = async (code) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/Companies/${code}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const CompaniesService = { getAllCompanies, getCompanies };

export default CompaniesService;
